<template>
  <component :is="tag" v-on="$listeners">
    <div class="d-flex align-items-center" style="width: 100vw">
      <div>
        <b-avatar
          size="35"
          :src="chat.image"
          badge
          class="badge-minimal mr-1"
          :badge-variant="chat.online ? 'success' : 'danger'"
          variant="primary"
        />
      </div>
      <div>
        <h6 class="mb-0">
          <span>{{
            `${chat.name} ${chat.first_name} ${chat.second_name}`
          }}</span>
        </h6>
        <p class="card-text truncate-text">
          {{ isChatContact ? chat.last_message : "" }}
        </p>
      </div>
    </div>
    <div v-if="isChatContact" class="chat-meta text-nowrap">
      <small class="float-right mb-25 chat-time">{{
        formatDateToMonthShort(chat.unread_from, {
          hour: "numeric",
          minute: "numeric",
        })
      }}</small>
      <b-badge v-if="chat.unreads" pill variant="primary" class="float-right">
        {{ chat.unreads }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from "bootstrap-vue";
import { formatDateToMonthShort } from "@core/utils/filter";

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    chat: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      dedfault: false,
    },
  },
  setup(props) {
    return { formatDateToMonthShort };
  },
};
</script>

<style lang="scss" scoped>
.truncate-text{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
